export default "__VITE_ASSET__DDBXA7nb__"